import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {
  htmlContent:SafeHtml = ""
  constructor(
    private appService: HttpClient,
    private _sanitizer: DomSanitizer) { }

  async ngOnInit() {
    this.getRawData().subscribe(
      data => this.htmlContent=this._sanitizer.bypassSecurityTrustHtml(data),
      error => console.log(error)
    );
  }

   getRawData(): Observable<any> {
    let urlPage = location.origin + '/page/privacy.php';
    //let urlPage = 'http://stcolumbas.pa.ecoachmanager.com/page/privacy.php';
    return this.appService.get(urlPage,{ responseType: 'text' });    
  }

}
